// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VurI","index":"styles_index__Lpa2G"};